module.exports = __webpack_public_path__ + "static/assets/40a2d492cde1a89028a00bdd8ea74c24.png";